import { render, staticRenderFns } from "./Valoration.vue?vue&type=template&id=68e05d87&scoped=true&"
import script from "./Valoration.vue?vue&type=script&lang=js&"
export * from "./Valoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e05d87",
  null
  
)

export default component.exports